import { EditorOptions } from './MarkdownEditor.types';

export const DEFAULT_EDITOR_OPTIONS: EditorOptions = {
  autofocus: false,
  forceSync: true,
  hideIcons: ['heading', 'fullscreen'],
  initialValue: '',
  placeholder: '',
  status: false,
  showIcons: [
    'heading-1',
    'heading-2',
    'heading-3',
    'bold',
    'italic',
    'strikethrough',
    'code',
    'quote',
    'unordered-list',
    'ordered-list',
    'link',
    'table',
    'horizontal-rule',
    'side-by-side',
    'guide',
  ],
};

export const HIDE_SIDE_BY_SIDE_OPTIONS: EditorOptions = {
  hideIcons: ['heading', 'side-by-side', 'fullscreen'],
};

export const README_EDITOR_OPTIONS: EditorOptions = { placeholder: 'Add README text' };
